import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\" stroke=\"#0F6378\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.136 7.944h0a4.305 4.305 0 0 0-2.868-1.078v0A4.268 4.268 0 0 0 1 10.6M5.268 5.801a2.4 2.4 0 1 0 0-4.801 2.4 2.4 0 0 0 0 4.801ZM12.203 4.734a1.867 1.867 0 1 0 0-3.734 1.867 1.867 0 0 0 0 3.734ZM14.977 6.866v0a3.2 3.2 0 0 0-5.182-.505M12.736 17a4.268 4.268 0 1 0 0-8.536 4.268 4.268 0 0 0 0 8.536Z\"></path><path d=\"m14.638 11.49-2.066 2.755v0a.534.534 0 0 1-.804.057L10.7 13.235\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h18.004v18H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }